import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import log from "./logo192.png"; // Adjust the path as needed
import {API_URL} from './config';

const Home = () => {
  const [particlesInit, setParticlesInit] = useState(null);
  const [userId, setUserId] = useState("");
  const [tripId, setTripId] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [rememberMe, setRememberMe] = useState(false);

  useEffect(() => {
    const initParticles = async () => {
      if (particlesInit) {
        await loadFull(particlesInit);
      }
    };
    initParticles();
  }, [particlesInit]);

  useEffect(() => {
    // Check local storage for saved user ID
    const savedUserId = localStorage.getItem("userId");
    if (savedUserId) {
      setUserId(savedUserId);
      setRememberMe(true); // Set checkbox to checked if there's a saved user ID
    }
  }, []);

  const navigateToTrip = async () => {
    if (!tripId) {
      setErrorMessage("Please enter a Trip ID.");
      return;
    }

    try {
      const response = await fetch(`${API_URL}/trip/${tripId}`);
      console.log('aaa',response);
      if (!response.ok) {
        throw new Error("Trip not found.");
      }
      
      const tripData = await response.json();
      console.log(tripData[0]);
      // Assuming tripData has a property 'cust_id' that holds the user ID
      if (tripData[0].cust_id === userId) {
        // Save user ID to local storage if "Remember Me" is checked
        if (rememberMe) {
          localStorage.setItem("userId", userId);
        } else {
          localStorage.removeItem("userId");
        }
        window.location.href = `/Track/${tripId}`;
      } else {
        setErrorMessage("User ID does not match the Trip ID.");
      }
    } catch (error) {
      setErrorMessage(error.message);
    }
  };

  return (
    <div className="relative h-screen flex flex-col">
      {/* Particles Background */}
      <Particles
        id="tsparticles"
        init={setParticlesInit}
        options={{
          particles: {
            number: {
              value: 150,
              density: {
                enable: true,
                value_area: 800,
              },
            },
            color: {
              value: "#022863",
            },
            links: {
              enable: true,
              color: "#022863",
              opacity: 0.3,
            },
            move: {
              enable: true,
              speed: 1,
            },
          },
        }}
        className="absolute inset-0"
      />

      {/* Top Bar */}
      <nav className="bg-[#022863] text-white p-6 shadow-lg z-10">
        <div className="container mx-auto flex items-center justify-between">
          <motion.h1
            className="text-xl font-bold"
            initial={{ rotate: -10 }}
            animate={{ rotate: 0 }}
            transition={{ duration: 0.5 }}
          >
            XGoLife
          </motion.h1>
          <div className="space-x-4">
            <a
              href="#"
              className="hover:text-[#ffc000] transition-colors duration-300"
            >
              About
            </a>
            <a
              href="#"
              className="hover:text-[#ffc000] transition-colors duration-300"
            >
              Contact
            </a>
          </div>
        </div>
      </nav>

      {/* Main Container */}
      <div className="relative z-10 flex-grow flex items-center justify-center">
        <div className="bg-[#ffc000] rounded-lg shadow-lg p-8 w-full max-w-lg mx-auto flex flex-col items-center justify-center">
          {/* Logo */}
          <img
            src={log}
            alt="XGoLife Logo"
            className="mb-8 w-48 sm:w-56 md:w-64"
          />

          <motion.p
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="mt-4 text-xl sm:text-2xl text-gray-600 text-center"
          >
            Experience a Tech Driven Lifestyle
          </motion.p>

          {errorMessage && (
            <p className="text-red-600 mt-4">{errorMessage}</p>
          )}

          <div className="mt-8 flex flex-col space-y-4 w-full">
            <motion.input
              type="text"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              placeholder="Enter User ID"
              className="border-2 border-gray-300 rounded-lg p-4 w-full focus:border-[#022863] focus:outline-none transition-all duration-300 shadow-md placeholder-[#022863]"
              required
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.4 }}
            />

            <motion.input
              type="text"
              value={tripId}
              onChange={(e) => setTripId(e.target.value)}
              placeholder="Enter Trip ID"
              className="border-2 border-gray-300 rounded-lg p-4 w-full focus:border-[#022863] focus:outline-none transition-all duration-300 shadow-md placeholder-[#022863]"
              required
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.4 }}
            />
          </div>

          <div className="flex items-center mt-4">
            <input
              type="checkbox"
              checked={rememberMe}
              onChange={() => setRememberMe(prev => !prev)}
              className="mr-2"
            />
            <label className="text-gray-600">Remember Me</label>
          </div>

          <motion.button
            onClick={navigateToTrip}
            className="mt-4 inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-[#022863] transition-colors duration-300 shadow-lg transform hover:scale-105"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            Go to Trip
          </motion.button>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white to-transparent" />
    </div>
  );
};

export default Home;